module.exports = __webpack_public_path__ + "img/copyright.69ce2ca8.png";